import { createCustomInstance } from './createCustomInstance';
import { generateRandomKey } from './generateRandomKey';

const customEmotion = createCustomInstance(
  // For snapshot stability, a static key is used when testing. The string `css`
  // was chosen as that is the default instance key.
  process.env.NODE_ENV === 'test' ? 'css' : generateRandomKey(),
);

// eslint-disable-next-line @typescript-eslint/unbound-method
export const {
  flush,
  hydrate,
  cx,
  merge,
  getRegisteredStyles,
  injectGlobal,
  keyframes,
  css,
  sheet,
  cache,
} = customEmotion;
